import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { hubLabel, normalizeHub, type HubKey } from "../core/hubs";

@Component({
  selector: "app-hub-flag",
  standalone: true,
  imports: [CommonModule],
  template: `
    <span
      class="hub-flag"
      [ngClass]="['hub-flag--' + (hubKey || 'unknown'), 'hub-flag--' + size]"
      role="img"
      [attr.aria-label]="label"
      [title]="label"
    >
      <span *ngIf="hubKey === 'brasil'" class="hub-flag__diamond">
        <span class="hub-flag__circle"></span>
      </span>
      <span *ngIf="hubKey === 'china'" class="hub-flag__star">★</span>
    </span>
  `,
  styles: [
    `
      .hub-flag {
        position: relative;
        display: inline-block;
        flex: 0 0 auto;
        overflow: hidden;
        border: 1px solid hsl(var(--border));
        border-radius: 0.18rem;
        box-shadow: 0 1px 2px hsl(var(--foreground) / 0.18);
        vertical-align: -0.15em;
      }

      .hub-flag--sm {
        width: 1.35rem;
        height: 0.92rem;
      }

      .hub-flag--md {
        width: 1.75rem;
        height: 1.18rem;
      }

      .hub-flag--lg {
        width: 2.25rem;
        height: 1.52rem;
      }

      .hub-flag--netherlands {
        background: linear-gradient(
          to bottom,
          #ae1c28 0 33.33%,
          #ffffff 33.33% 66.66%,
          #21468b 66.66% 100%
        );
      }

      .hub-flag--sweden {
        background: #006aa7;
      }

      .hub-flag--sweden::before,
      .hub-flag--sweden::after {
        position: absolute;
        content: "";
        background: #fecc00;
      }

      .hub-flag--sweden::before {
        left: 31%;
        top: 0;
        width: 14%;
        height: 100%;
      }

      .hub-flag--sweden::after {
        left: 0;
        top: 42%;
        width: 100%;
        height: 16%;
      }

      .hub-flag--brasil {
        display: inline-grid;
        place-items: center;
        background: #009b3a;
      }

      .hub-flag__diamond {
        display: grid;
        width: 72%;
        height: 72%;
        place-items: center;
        background: #ffdf00;
        clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
      }

      .hub-flag__circle {
        width: 36%;
        height: 36%;
        border-radius: 999px;
        background: #002776;
      }

      .hub-flag--china {
        background: #de2910;
      }

      .hub-flag__star {
        position: absolute;
        left: 12%;
        top: 4%;
        color: #ffde00;
        font-size: 0.72em;
        line-height: 1;
      }

      .hub-flag--unknown {
        background: linear-gradient(
          135deg,
          hsl(var(--muted)),
          hsl(var(--background))
        );
      }
    `,
  ],
})
export class HubFlagComponent {
  @Input() hub: string | null | undefined;
  @Input() size: "sm" | "md" | "lg" = "md";

  get hubKey(): HubKey | null {
    return normalizeHub(this.hub);
  }

  get label() {
    return hubLabel(this.hub);
  }
}
